import { useState } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import useAlert from '../../Alerts/useAlert';
import DateAsLocaleString from '../../Utilities/DateAsLocaleString';
import AdminTile from './AdminTile';
import { Sample } from '../../Types/Sample';

const GetSample = () => {
    const { businessUnits } = useBusinessUnits(false);
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [samples, setSample] = useState<Sample[]>();
    const [sampleId, setSampleId] = useState("");
    const [error, setError] = useState<string | null>();
    const [variant, setVariant] = useState<string>("");
    const [businessUnit, setBusinessUnit] = useState("");

    const getSample = () => {
        if (!businessUnit) {
            return;
        }

        fetchDataAuthenticated(`api/v1/admin/sample/${businessUnit}?sampleId=${sampleId}`, "GET")
            .then(response => {
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setVariant("");
                setSample(data);
                setError(null);
            }).catch(error => {
                setVariant("danger");
                setAlert("danger", error.title, error.detail)
                setSample(undefined);
                setError(error.detail);
            });
    }

    return (
        <AdminTile
            title={"Get Samples"}
            description={"Send a request to SM-API to fetch a sample"}
            variant={variant}>
            <>
                {samples &&
                    <>
                        <Row>
                            <Col>
                                Sample Id:
                            </Col>
                            <Col>
                                {samples[0].sampleId}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Sampled Date:
                            </Col>
                            <Col>
                                <DateAsLocaleString date={samples[0].sampledDate} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Tests in Sample:
                            </Col>
                            <Col>
                                {samples[0].tests.length}
                            </Col>
                        </Row>
                    </>
                }
                <Row className="mt-1">
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>Business Unit</strong></Form.Label>
                            <Form.Select className="config-select" value={businessUnit} onChange={(e) => setBusinessUnit(e.target.value)}>
                                <option value="" key={0} >Please Select...</option>
                                {businessUnits.map((bu) => <option value={bu.businessUnitId} key={bu.businessUnitId}>{bu.name}</option>)}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mt-1">
                            <Form.Label><strong>Sample ID</strong></Form.Label>
                            <Form.Control type="text" value={sampleId} onChange={(e) => setSampleId(e.target.value)} />
                        </Form.Group>
                    </Form>
                </Row>
                {error &&
                    <div>
                        {error}
                    </div>}
                <Button type="submit" className="ms-auto mt-auto" onClick={getSample}>Get</Button>
            </>
        </AdminTile>
    );
}

export default GetSample;